import { writable } from 'svelte/store';
import { z } from 'zod';
import { ColumnSettingsSchema } from './types';

export const ImportFileTypeSchema = z.enum(['connections', 'locations']).describe('connections | locations');
export type ImportFileTypeType = z.infer<typeof ImportFileTypeSchema>;

export const ImportCreateRequestSchema = z.object({
    name: z.string(),
    file_type: ImportFileTypeSchema,
    import_type: z.string().describe('upsert | overwrite'),
});
export type ImportCreateRequestType = z.infer<typeof ImportCreateRequestSchema>;

export const ImportRequestSchema = z.object({
    columns_assignment: ColumnSettingsSchema.nullable(),
});
export type ImportRequestType = z.infer<typeof ImportRequestSchema>;

export const ImportResponseSchema = ImportRequestSchema.merge(
    z.object({
        created: z.string(),
        file_type: ImportFileTypeSchema,
        import_type: z.string().describe('upsert | overwrite'),
        filename: z.string().nullable(),
        id: z.coerce.number(),
        webuser_id: z.coerce.number(),
        uploaded: z.string().nullable(),
        geocode_completed: z.boolean(),
        locations_created: z.boolean(),
        error: z.string().nullable().default(null).describe('datetime of error appear'),
        geocoding_started: z
            .string()
            .regex(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)
            .nullable(),
    })
).nullable();
export type ImportResponseType = z.infer<typeof ImportResponseSchema>;

export let currentImport = writable<ImportResponseType>(null);

export const TasksStatusResponseSchema = z.object({
    tasks_total: z.number(),
    tasks_done: z.number(),
    percent: z.number(),
});
export type TasksStatusResponseType = z.infer<typeof TasksStatusResponseSchema>;
